module.exports = "https://www.gc-qa.gnp.com.mx/c4de313f0b595d494e5d7e13bce13fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/tramites/2.png
// module id = 1063
// module chunks = 0 1